import * as stylex from "@stylexjs/stylex";
import { layoutAreas } from "../../materials/consts.stylex";
// LandingText's `children` is MDX content — StyleX can't reach its `p`/`a` elements
// directly, so their type styles live in style.global.css, scoped by this marker class.
export const LandingText = ({ children })=>{
    return <div className={`landing-text-content ${({
        className: "x1uq3dmu x1sfqgxf"
    }).className}`}>{children}</div>;
};
